/**
 * 跟进池页面视觉配置（改这里即可，无需翻组件代码）
 */
export const FOLLOW_POOL_UI = {
  /** 「跟进中的组合」股卡片外框区域的背景（略灰区分于整块白衬底）；支持任意合法 CSS background */
  poolShellBackground: "#ffffff",
  /** 「组合动态」列表单行 hover 时的背景（任意合法 CSS background，默认与原先的半透明灰一致） */
  opsRowHoverBackground: "rgba(15, 23, 42, 0.055)",
  /**
   * 股池卡片「建仓日/持股天数」里括号内日数字样的颜色（合法 CSS color）；
   * 会写入根节点 CSS 变量 `--lf-fp-holding-days-color`，也可在样式表里直接覆盖该变量
   */
  holdingDaysColor: "rgb(255, 94, 0)",
} as const;
